/**
 * FAQ Accordion — toggles a question's answer open/closed.
 * Each .faq-item gets an .is-open class; the answer animates via CSS
 * (grid-template-rows) and the plus icon rotates 45° into an ✕.
 */
export function faqAccordion() {
  const toggles = document.querySelectorAll('.faq-toggle');
  if (!toggles.length) return;

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.faq-item');
      if (!item) return;

      const isOpen = item.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });
}
